module.exports = __webpack_public_path__ + "71432fb74c5095cd9d69fa06ab787c91.svg";